import { ListItem } from '@core/models/common/list-item';
import {
    LIST_ITEMS_UNSET_ALL,
    LIST_ITEM_SET,
    LIST_ITEM_UNSET,
    LIST_MERGE,
    LIST_SET
} from '@core/state/action-types';
import { removeObjectKey } from '@core/utils/object';
import { createReducer } from '@core/utils/state';

export const entitiesListReducer = createReducer({}, {

    /**
     * Sets the items as the entities.
     * @param state
     * @param payload
     * @returns {{}}
     */
    [LIST_SET]: (state, { payload }) => {
        const domain: string = payload.domain;
        return { ...state, ...payload.entities[domain] };
    },

    /**
     * Merges the items with the existing entities.
     * @param state
     * @param payload
     * @returns {{}}
     */
    [LIST_MERGE]: (state, { payload }) => {
        const domain = payload.domain;
        return { ...state, ...payload.entities[domain]};
    },

    /**
     * Sets an item on the entities domain.
     * @param state
     * @param payload
     * @returns {{}}
     */
    [LIST_ITEM_SET]: (state, { payload }) => {
        const stateChange: any = { ...state };
        const item: ListItem = payload.item as ListItem;

        let idAttr: string = 'id';

        if (payload.schema && payload.schema._idAttribute) {
            idAttr = payload.schema._idAttribute
        }

        const itemId: string = item[idAttr];

        stateChange[itemId] = item;

        return { ...stateChange };
    },

    /**
     * Unsets / Deletes an item from the entities.
     * @param state
     * @param payload
     * @returns {any}
     */
    [LIST_ITEM_UNSET]: (state, { payload }) => {
        return removeObjectKey(payload.id, state);
    },

    [LIST_ITEMS_UNSET_ALL]: (state, {payload}) => {
        const stateChange: any = payload && payload.preserveEntities ? state : {};
        return { ...stateChange };
    }
});
